import React from "react";
import { Grid, IconButton } from "@material-ui/core";
import { ChevronLeft, ChevronRight } from "@material-ui/icons";
import PropTypes from "prop-types";

const Carousel = ({ onNext, onPrev, currentIndex, totalItems, children }) => {
  return (
    <Grid container justify="space-between" alignItems="center" spacing={1}>
      <Grid item>
        <IconButton onClick={onPrev} disabled={currentIndex === 0}>
          <ChevronLeft />
        </IconButton>
      </Grid>
      <Grid item xs>
        {children}
      </Grid>
      <Grid item>
        <IconButton onClick={onNext} disabled={currentIndex + 1 === totalItems}>
          <ChevronRight />
        </IconButton>
      </Grid>
    </Grid>
  );
};

Carousel.propTypes = {
  totalItems: PropTypes.number.isRequired,
  currentIndex: PropTypes.number.isRequired,
  onPrev: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired
};

export { Carousel };
